import React, { PureComponent } from 'react'
import { func, arrayOf } from 'prop-types'

import PaymentMethodDelPopup from '../../../payments/components/common/PaymentMethodDelPopup'
import { paymentMethodPropType } from '../../../payments/components/common/paymentMethodTypes'
import PaymentMethodSwitch from '../../../payments/components/common/PaymentMethodSwitch'
import PaymentMethodList from '../PaymentMethodList'
import I18nMessage from '../../../common/I18nMessage'
import '../wallet.components.scss'
import './PaymentMethodView.scss'

const defaultPopupState = {
  isShowDelPopup: false,
}

class PaymentMethodView extends PureComponent {
  static propTypes = {
    createablePaymentMethods: arrayOf(String).isRequired,
    paymentMethods: arrayOf(paymentMethodPropType),
    handleAddPaymentMethod: func.isRequired,
    handleEditPaymentMethod: func.isRequired,
    handleDeletePaymentMethod: func.isRequired,
    handleChangePrimaryMethod: func.isRequired,
  }

  static defaultProps = {
    paymentMethods: [],
  }

  constructor(props) {
    super(props)
    this.state = {
      selected: null,
      ...defaultPopupState,
    }
  }

  componentDidMount() {
    const { isShowDelPopup } = this.state
    if (isShowDelPopup) {
      this.autoFocus()
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { isShowDelPopup } = this.state
    if (prevState.isShowDelPopup !== isShowDelPopup) {
      if (isShowDelPopup) {
        this.autoFocus()
      } else {
        clearTimeout(this.removeTimer)
      }
    }
  }

  autoFocus = () => {
    this.removeTimer = setTimeout(() => {
      clearTimeout(this.removeTimer)
    }, 100)
  }

  updatePopupState = updated => {
    this.setState({ ...defaultPopupState, ...updated })
  }

  handleConfirmDel = selected => {
    this.updatePopupState({ selected, isShowDelPopup: true })
  }

  handleCancel = () => {
    this.updatePopupState({ selected: null, isShowDelPopup: false })
  }

  handleDelete = () => {
    const { handleDeletePaymentMethod } = this.props
    const { selected } = this.state
    handleDeletePaymentMethod(selected, this.handleCancel)
  }

  render() {
    const {
      paymentMethods,
      handleEditPaymentMethod,
      handleChangePrimaryMethod,
      handleAddPaymentMethod,
      createablePaymentMethods,
    } = this.props
    const {
      selected, isShowDelPopup,
    } = this.state

    return (
      <div className="passport__wallet__components passport__wallet-view">
        <h1 className="passport__wallet-view--title">
          <I18nMessage id="passport.wallet.title" />
        </h1>
        <div className="passport__wallet-view--subtitle">
          <I18nMessage id="passport.wallet.subtitle" />
        </div>
        <div className="passport__wallet-view--list">
          <PaymentMethodList
            paymentMethods={paymentMethods}
            handleEditPaymentMethod={handleEditPaymentMethod}
            handleDelPaymentMethod={this.handleConfirmDel}
            handleChangePrimaryMethod={handleChangePrimaryMethod}
          />
        </div>
        <div className="passport__wallet-view--add">
          <PaymentMethodSwitch
            handleAddPaymentMethod={handleAddPaymentMethod}
            paymentMethodsType={createablePaymentMethods}
          />
        </div>
        {isShowDelPopup && (
          <div
            className="passport__wallet-view--del-popup"
          >
            <PaymentMethodDelPopup
              isShow={isShowDelPopup}
              paymentMethod={selected}
              handleDeletePaymentMethod={this.handleDelete}
              handlePaymentDelPopupCancel={this.handleCancel}
            />
          </div>
        )}
      </div>
    )
  }
}

export default PaymentMethodView
